import { setImagesAndInitSlider } from "./Library";

_gg.domJsReady(setImagesAndInitSlider);

window.addEventListener("resize", function () {
    window.requestAnimationFrame(setImagesAndInitSlider);
});
